import { createSelector } from "reselect";
import { getPropertyDisplayName } from "@appcues/libcues/dist/conditions/utils";
import * as actionTypes from "constants/actionTypes";
import { isAutoProperty } from "utils/events-properties";
import { getOptGroup } from "utils";

const initialState = {
  synced: false,
  attributes: {}
};

export default function profileAttributes(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_PROFILE_ATTRIBUTE_IN_STORE:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [action.payload.attributeId]: {
            ...state.attributes[action.payload.attributeId],
            ...action.payload.changes
          }
        }
      };

    case actionTypes.REPLACE_ACCOUNT_PROFILE_ATTRIBUTE:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          [action.payload.attributeId]: action.payload.attribute
        }
      };
    case actionTypes.REPLACE_ACCOUNT_PROFILE_ATTRIBUTES: {
      let attributes = action.payload;

      return {
        synced: true,

        attributes: Object.keys(attributes).reduce((prev, name) => {
          return {
            ...prev,
            [name]: attributes[name]
          };
        }, {})
      };
    }
    case actionTypes.DELETE_ACCOUNT_PROFILE_ATTRIBUTE_IN_STORE: {
      let { profileAttributeId } = action.payload;
      const {
        [profileAttributeId]: omit,
        ...stateWithoutProfileAttribute
      } = state.attributes;
      return { ...state, attributes: stateWithoutProfileAttribute };
    }

    case actionTypes.CLEAR_ACCOUNT_DATA:
      return initialState;
    default:
      return state;
  }
}

export const selectAccountProfileAttribute = (state, attributeId) =>
  state.account.profileAttributes.attributes[attributeId];

export const selectAccountProfileAttributes = state =>
  state.account.profileAttributes.attributes;

export const selectFilteredProfileAttributes = createSelector(
  [selectAccountProfileAttributes],
  attributes => {
    const ignoredAttributes = ["_ABGroup", "_testContentId"];
    return Object.values(attributes)
      .filter(({ name }) => !ignoredAttributes.includes(name))
      .reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
      }, {});
  }
);

export const selectAccountProfileAttributeIdsByName = createSelector(
  [selectAccountProfileAttributes],
  attributes =>
    Object.values(attributes).reduce((acc, attribute) => {
      acc[attribute.name] = attribute.id;
      return acc;
    }, {})
);

export const selectAccountProfileAttributeByName = (state, name) => {
  return (
    selectAccountProfileAttribute(
      state,
      selectAccountProfileAttributeIdsByName(state)[name]
    ) || {}
  );
};

export const selectProfileCustomProperties = createSelector(
  [selectAccountProfileAttributes],
  attribute => {
    const customProperties = Object.values(attribute).filter(property => {
      return !isAutoProperty(property);
    });
    return customProperties;
  }
);

export const selectProfileAutoProperties = createSelector(
  [selectAccountProfileAttributes],
  attributes => {
    const autoProperties = Object.values(attributes).filter(attribute => {
      return isAutoProperty(attribute);
    });
    return autoProperties;
  }
);

export const selectProfileAttributeDropdownOptions = createSelector(
  [selectFilteredProfileAttributes],
  attributes =>
    Object.values(
      Object.values(attributes)
        .filter(
          ({ name, showInUI }) => name && (showInUI === undefined || !!showInUI)
        )
        .map(({ label, name: value }) => ({
          label: label || getPropertyDisplayName(value),
          value,
          isAutoProp: value.match(/^_/),
          group: getOptGroup(value)
        }))
        .reduce(
          (acc, option) => {
            const { group } = option;
            if (acc[group]) {
              acc[group].options.push(option);
            }
            return acc;
          },
          {
            normal: {
              label: "CUSTOM PROPERTIES",
              options: [],
              order: 1
            },
            form: {
              label: "FORM RESPONSES",
              options: [],
              order: 2
            },
            device: {
              label: "DEVICE PROPERTIES",
              options: [],
              order: 3
            },
            satisfaction: {
              label: "USER SATISFACTION",
              options: [],
              order: 4
            },
            auto: {
              label: "AUTO-PROPERTIES",
              options: [],
              order: 5
            }
          }
        )
    )
);
